import PropTypes from "prop-types";

import { getBluFilterElt } from "./BluFilterElt";

/*
Constants and helpers
*/

const INPUT_MAX_LENGTH = 50;
const INPUT_PLACEHOLDER = "10.20.30.0/24...";
const INPUT_REGEX_COMPLETE = /^$|^[0-9a-fA-F:.]+(?:\/\d+)?$/;
const INPUT_REGEX_PARTIAL = /^$|^[0-9a-fA-F:.]+(?:\/\d*)?$/;

/*
Component
*/
const IpFilterElt = getBluFilterElt({
  INPUT_MAX_LENGTH,
  INPUT_PLACEHOLDER,
  INPUT_REGEX_COMPLETE,
  INPUT_REGEX_PARTIAL,
});

IpFilterElt.propTypes = {
  filterValue: PropTypes.string,
  fieldName: PropTypes.string,
  setFilter: PropTypes.func,
};

IpFilterElt.defaultProps = {
  filterValue: "",
  fieldName: "",
  setFilter: () => {},
};

export default IpFilterElt;
